 import React from 'react';
import './FeedbackModerationModal.css';

const FeedbackModerationModal = ({ book, feedbacks, onClose, onDelete }) => {
  return (
    <div className="modal-backdrop">
      <div className="modal-content feedback-modal">
        <div className="modal-header">
          <h2>Visszajelzések: "{book.title}"</h2>
          <button onClick={onClose} className="close-button">&times;</button>
        </div>
        <div className="modal-body">
          {feedbacks.length > 0 ? (
            <ul className="feedback-list-admin">
              {feedbacks.slice(0).reverse().map(fb => (
                <li key={fb.timestamp} className="feedback-item-admin">
                  <div className="feedback-content-admin">
                    <div className="feedback-header-admin">
                      <span className="feedback-nickname-admin">{fb.nickname}</span>
                      <span className="feedback-stars-admin">
                        {'★'.repeat(fb.rating)}{'☆'.repeat(5 - fb.rating)}
                      </span>
                    </div>
                    <p className="feedback-text-admin">{fb.text}</p>
                    <small className="feedback-meta-admin">
                      {new Date(fb.timestamp).toLocaleString()} | {fb.email}
                    </small>
                  </div>
                  <button onClick={() => onDelete(fb.timestamp)} className="action-button delete">
                    Törlés
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <p>Nincsenek visszajelzések ehhez a könyvhöz.</p>
          )}
        </div>
        <div className="modal-footer">
          <button onClick={onClose} className="cancel-button">Bezárás</button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModerationModal;